import { Layout as AntLayout } from "antd";
import { colors } from "pages/Home/Home.styles";
import styled from "styled-components";
const { Footer: AntFooter } = AntLayout;
export const FooterAnt = styled(AntFooter)`
  background-image: ${({ image }) => `url(${image ?? ""})`};
  background-size: 100% 100%;
  background-position: 0% 0%;
  background-color: transparent;
  background-repeat: no-repeat;
  padding: 0px;
  padding-bottom: 20px;
  .terminos {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .Row-left--content {
    padding-top: 60px;
    justify-content: space-evenly;
  }

  .Col-leftfooter--logo {
    display: flex;
    svg {
      width: 160px;
    }
  }

  .Col-leftfooter--info {
    color: #ffff;

    span {
      font-weight: 400;
      font-family: "Roboto", sans-serif;
      margin-bottom: 0px;
      color: #ffff;
      padding: 0px;
      font-size: 14px;
    }
  }
  .phone-number {
    display: flex;
    align-items: center;
    column-gap: 10px;
  }
  .Col-leftfooter--infoContact {
    .buttonWs {
      background: #00d3b0 !important;
      border-radius: 40px;
      font-size: 14px !important;
      font-weight: 500;
      font-family: "Rubik", sans-serif;
      border-color: #00d3b0;
      padding: 5px 30px;
      span {
        color: #fff;
      }
    }

    p {
      color: #ffff;
      margin-bottom: 0px;
      font-family: "Roboto", sans-serif;
      font-size: 14px;
      font-weight: 400;
    }

    span {
      color: #00d3b0;
      font-family: "Roboto", sans-serif;
      font-weight: 400;
    }
  }

  .Row-Content--social {
    padding: 0px 0 0 35px;

    p {
      color: #ffff;
      font-family: "Roboto", sans-serif;
      font-size: 16px;
      font-weight: 400;
    }

    .default-text {
      font-size: 14px;
      font-weight: 600;
      color: ${colors.white};
      font-family: "Rubik", sans-serif;
    }
    .ant-btn {
      padding: 4px 0px;
    }
  }
  .separate {
    border-right: 1px solid #fff;
    padding: 0 20px;
  }
  .social-media {
    display: flex;
    align-items: center;
    column-gap: 10px;
  }
  .Row-Content--copyright {
    max-width: 1440px;
    margin: auto;
    padding-left: 60px;
    height: 55px;
    align-items: center;
  }

  .Col-Content--copyright {
    p {
      color: #ffff;
      margin-bottom: 0px;
      font-family: "Roboto", sans-serif;
      font-weight: 700;
    }
  }

  .Col-Content--flags {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    p {
      color: #ffff;
      margin-bottom: 0px;
      font-family: "Roboto", sans-serif;
      font-weight: 700;
    }
  }

  .gradiente-border {
    max-width: 1440px;
    margin: auto;
    height: 2px;
    display: flex;
    background-image: linear-gradient(
      to right,
      rgb(66, 27, 136) 0%,
      rgb(255, 23, 68) 100%
    );
  }
  @media (max-width: 992px) {
    .Row-left--content {
      margin: 0 50px;
    }

    .Col-leftfooter--info {
      padding: 0px 0px;
      span {
        font-size: 18px;
      }
    }

    .Col-leftfooter--infoContact {
      .button-ws {
        height: 64px !important;
        margin-bottom: 10px;
        span {
          font-size: 19px;
        }
      }

      p {
        font-size: 18px !important;
      }
    }

    .Row-Content--social {
      padding-bottom: 80px !important;
      padding-left: 0px !important;

      svg {
        height: 42px;
        width: 42px;
      }

      .icon-twitter {
        height: 40px;
        width: 40px;
      }

      p {
        font-size: 18px !important;
      }
    }

    .Row-Content--copyright {
      height: 120px !important;
      margin-left: 0px !important;
      padding-left: 0px !important;
      p {
        font-size: 18px;
      }

      svg {
        width: 28px !important;
        height: 21px !important;
      }

      .Col-Content--copyright {
        text-align: center;
        order: 2 !important;
        margin-bottom: 20px;
      }

      .Col-Content--flags {
        justify-content: center !important;
        margin-top: 20px;
      }
    }
  }
  @media (max-width: 990px) {
    .Row-Content--social {
      padding-left: 0px !important;
      padding-bottom: 20px !important;
    }


  .main-cols {
    padding-left 20px;
    padding-right 20px;
  }
    .ant-btn {
      padding: 4px 0px
    }
  }
  @media (max-width: 770px) {
    background-image: ${({ image2 }) => `url(${image2 ?? ""})`};
    padding-top: 0px;
    position: relative;
    .separate {
      padding: 0 20px 0px;
    }
    .circle {
      width: 100%;
      height: 80px;
      background-color: ${colors.background};
      border-bottom-left-radius: 50%;
      border-bottom-right-radius: 50%;
    }
    .Row-Content--social {
      padding-left: 0px !important;
      padding-bottom: 20px !important;
    }
  }
    .wpp-container {
      display: flex;
      width: 100%;
    }
  @media (max-width: 575px) {
    .separate {
      border-right: none;
    }
      .wpp-container {
      justify-content: center;
    }
    .ant-col {
      justify-content: center;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
    .default-text {
      font-size: 14px;
      font-weight: 600;
      color: ${colors.white};
      font-family: "Rubik", sans-serif;
    }
`;
